import React from 'react'
import { connect } from 'react-redux'
import { fetchSubsidiary, updateSubsidiary } from '../../actions/subsidiary-actions'
import { fetchIdentityProvidersFor } from '../../actions/idp-actions'
import { Grid, Row, Col, FormGroup, ControlLabel, Button, Form} from 'react-bootstrap'
import { isEmpty, set } from 'lodash'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { DropdownList } from 'react-widgets'

import Breadcrumbs from '../../components/Breadcrumbs'
import PropertyTitle from '../../components/PropertyTitle'
import PropertyInput from '../../components/PropertyInput'
import NotFound from '../NotFound'
import { importPDFTemplate } from '../../services/Subsidiaries'

class SubsidiaryDetail extends React.Component {

  constructor() {
    super()
    this.state = { idp : -1 }
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.fileUpload = this.fileUpload.bind(this)
  }

  componentDidMount() {
    this.props.fetchSubsidiary(this.props.match.params.id)
    this.props.fetchIdentityProvidersFor(this.props.match.params.id)
  }

  componentDidUpdate(oldProps) {
    if (this.props.match.params.id !== oldProps.match.params.id) {
      this.props.fetchSubsidiary(this.props.match.params.id)
      this.props.fetchIdentityProvidersFor(this.props.match.params.id)
    }
  }

  onSave(property, value) {
    let subsidiary = this.props.subsidiary
    set(subsidiary, property, value)
    this.onSaveSubsidiary(subsidiary)
  }

  onSaveSubsidiary(subsidiary) {
    this.props.updateSubsidiary(subsidiary).then(() => {
      this.props.fetchSubsidiary(this.props.match.params.id)
    })
  }

  selectIdp(e) {
    this.setState({idp: e.id})
  }

  exportLicenses() {
    axios.get(`/api/idp/${this.state.idp}/licenses`,{headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},responseType: 'arraybuffer'},{})
      .then( result => {
        let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        saveAs(blob, 'licenties.xlsx')
      })
  }

  onFormSubmit(e){
    e.preventDefault() // Stop form submit
    this.fileUpload(this.state.file).then((response)=>{
      alert('PDF succesvol upgeload.')
    }).catch((error) => alert('Er is iets misgegaan met de upload. Neem aub. contact op met de systeembeheerder.' + error))
  }

  onChange(e) {
    this.setState({file:e.target.files[0]})
  }

  fileUpload(file){
    const formData = new FormData();
    formData.append('file',file)
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return importPDFTemplate(this.props.subsidiary.id, formData,config)
  }

  downloadPDFTemplate() {
    axios.get(`/api/subsidiaries/${this.props.subsidiary.id}/activationCodePDFTemplate`,{headers: {'Accept': 'application/application/pdf'},responseType: 'arraybuffer'},{})
      .then( result => {
        let blob = new Blob([result.data], { type: 'application/application/pdf' })
        saveAs(blob, 'template_' + this.props.subsidiary.name + '.pdf')
      })
  }

  render() {
    const { subsidiary, identityProviders } = this.props
    if (subsidiary && subsidiary===-1) {
      return <NotFound/>
    }
    if (isEmpty(subsidiary) || subsidiary.id !== parseInt(this.props.match.params.id, 10)) {
	  return null
	}

    const disabled = !this.props.roles || this.props.roles.indexOf('admin')===-1

    return <Grid>
      <Breadcrumbs title={subsidiary.name} />

      <Row>
        <div className='content'>
          <Row>
            <Col xs={12}><span className='title' id='title'><b>Werkmaatschappij</b></span></Col>
          </Row>
          <Row>
            <Col md={6} xs={12}>
              <PropertyTitle 
                icon='university' 
                text={subsidiary.name} 
              />
              <PropertyInput 
                icon='university' 
                className='name' 
                label='Naam' 
                type='text' 
                property='name' 
                value={subsidiary.name} 
                onSave={(property, value) => this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
              <PropertyInput 
                icon='barcode' 
                className='activationCodePrefix' 
                label='Activatiecode prefix' 
                type='text' 
                property='activationCodePrefix' 
                value={subsidiary.activationCodePrefix} 
                onSave={(property, value) => this.onSave(property, value)}
                entity='subsidiary' entityId={subsidiary.id} disabled={disabled}
              />
              <PropertyInput 
                icon='envelope-o' 
                className='activationMailTemplate' 
                label='Activatiemail template' 
                type='text' 
                property='activationMailTemplate' 
                value={subsidiary.activationMailTemplate} 
                onSave={(property, value) => this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
              <PropertyInput 
                icon='code' 
                className='code' 
                label='Code' 
                type='text' 
                property='code' 
                value={subsidiary.code} 
                onSave={(property, value) => this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
          </Col>
            <Col md={6} xs={12}>
              <PropertyTitle 
                className='visible-lg-block visible-md-block' 
              />
              <PropertyInput 
                icon='id-card-o' 
                className='ldapId' 
                label='LDAP ID' 
                type='text' 
                property='ldapId' 
                value={subsidiary.ldapId} 
                onSave={(property, value) => this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
              <PropertyInput 
                icon='calendar-check-o' 
                className='defaultGracePeriod' 
                label='Default grace period' 
                type='period' 
                property='defaultGracePeriod' 
                value={subsidiary.defaultGracePeriod} 
                onSave={(property, value) => this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
              <PropertyInput 
                icon='database' 
                className='defaultIdentityProvider' 
                label='Default identity provider' 
                type='choice' 
                property='defaultIdentityProvider' 
                value={subsidiary.defaultIdentityProvider} 
                choices={identityProviders} 
                onSave={(property, value) => this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
              <PropertyInput 
                icon='envelope-o' 
                label='Management email' 
                type='text' 
                property='managementMail' 
                value={subsidiary.managementMail} 
                onSave={(property, value)=> this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
              <PropertyInput 
                icon='envelope-o' 
                label='Grace-period email' 
                type='text' 
                property='gracePeriodMail' 
                value={subsidiary.gracePeriodMail} 
                onSave={(property, value)=> this.onSave(property, value)}
                entity='subsidiary' 
                entityId={subsidiary.id} 
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
            <Form horizontal>
              <FormGroup controlId='selectIDP'>
                <Col componentClass={ControlLabel} sm={2}>
                Identity provider
                </Col>
                <Col sm={4}>
                  <DropdownList 
                    placeholder='Selecteer IDP'
                    textField='name'
                    valueField='id'
                    data={ this.props.identityProviders }
                    onChange={(e) => this.selectIdp(e)} 
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <div className='col-xs-6 text-right'>
                  <Button 
                    type='button'
                    onClick={()=>this.exportLicenses()}
                    disabled={this.state.idp<0}
                    bsStyle='success'>Exporteer licenties
                  </Button>
                </div>
                <div className='col-xs-6'>
                  <div className='col-xs-12'>
                    <input 
                      type="file" 
                      onChange={this.onChange} 
                      accept='.pdf, .PDF' 
                      required={true} 
                    />
                  </div>
                  <div className='col-xs-6'>
                    <Button 
                      type="submit" 
                      bsStyle='success' 
                      disabled={!this.state.file} 
                      onClick={this.onFormSubmit}>Upload PDF template
                    </Button>
                  </div>
                  <div className='col-xs-6 text-right'>
                    <Button 
                      type='button'
                      onClick={()=>this.downloadPDFTemplate()}
                      bsStyle='success'>Download PDF template
                    </Button>
                  </div>
                </div>
              </FormGroup>
            </Form>
            </Col>
          </Row>
        </div>
      </Row>
    </Grid>
  }

}

export default connect(((state) => { return { 
  subsidiary: state.subsidiaries.detail, 
  identityProviders: state.identityProviders.list, 
  roles: state.keycloak.realmAccess.roles 
} }), {
  fetchSubsidiary, updateSubsidiary, fetchIdentityProvidersFor
})(SubsidiaryDetail)
